import { PinFrequencyDocumentType } from "@/Common/Models/UI/Enums";
import { BaseSendMedicalNoteItemToPortalPopupStrategy } from "./Strategies/BaseSendMedicalNoteItemToPortalPopupStrategy";
import { ISharedItemProvider } from "./ISharedItemProvider";

class DefaultSharedItemProvider implements ISharedItemProvider {
    public getSharedItemTypeLabel(): string {
        return cacheStore.GetString("DocumentLabel");
    }

    public getItemIconClass(): string {
        return "";
    }

    public shouldShowFilePreviewInPortfolio(): boolean {
        return false;
    }

    public createSendMedicalNoteItemToPortalPopupStrategy(): BaseSendMedicalNoteItemToPortalPopupStrategy | null {
        return null;
    }

    public getPinFrequencyToken(): string {
        return "";
    }

    public getPinFrequencyDocumentType(): PinFrequencyDocumentType | null {
        return null;
    }
}

export { DefaultSharedItemProvider };
